module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/admin/admin.html
// module id = 465
// module chunks = 0